import { Draft } from 'immer';
import TariffResponse from '../../../interface/TariffResponse';
import { initStore } from '../action';
import { StateProps } from '../interface';
import { findSubscription, findTariffById } from './selectorHelper';

const selectSubscription = (draft: Draft<StateProps>, subscriptionId: string) => {
    const currentTariff = findTariffById(draft.tariffs, draft.selectedOption.hardwareId);
    const newSubscription = findSubscription(currentTariff, subscriptionId, draft.salesChannel);
    if (newSubscription) {
        draft.selectedOption.subscriptionId = subscriptionId;
        draft.selectedOption.subscription = newSubscription;

        return;
    }

    draft.tariffs && draft.tariffs.every(tariff => {
        const newSub = findSubscription(tariff, subscriptionId, draft.salesChannel);

        if (!newSub) {
            return true;
        }
        draft.selectedOption.subscription = newSub;
        draft.selectedOption.subscriptionId = newSub.legacyGroupId.toString();
        draft.selectedOption.hardware = tariff.hardware;
        draft.selectedOption.hardwareId = tariff.hardware.hardwareId.toString();

        return false;
    });
};

/**
 * Different hardwares have different subscriptions so on hardware change
 * the subscription also changes, and we need to update the selected subscription
 */
const selectHardware = (draft: Draft<StateProps>, newHardwareId?: string) => {
    const newTariff = findTariffById(draft.tariffs, newHardwareId);

    draft.selectedOption.hardwareId = newHardwareId;
    draft.selectedOption.hardware = newTariff?.hardware;
    draft.selectedOption.subscription = findSubscription(newTariff, draft.selectedOption.subscriptionId, draft.salesChannel);
};

export const handleInitStore = (draft: Draft<StateProps>, action: ReturnType<typeof initStore>) => {
    for (const key in action.payload) {
        draft[key] = action.payload[key];
    }
};

/**
 * Handles the selection of new hardware and/or subscription
 * @param draft StateProps
 * @param subscriptionId new subscription id
 * @param hardwareId new hardware id
 */
export const handleSelectOption = (draft: Draft<StateProps>, subscriptionId?: string, hardwareId?: string) => {
    if (subscriptionId) {
        selectSubscription(draft, subscriptionId);
    }

    if (hardwareId) {
        selectHardware(draft, hardwareId);
    }
};

/**
 * Saves the offers and also sets a default selection for hardware and subscription
 *
 * @param draft StateProps
 * @param response OfferResponse received from API
 */
export const handleOffersSuccess = (draft: Draft<StateProps>, response: TariffResponse) => {
    draft.tariffs = response.data;
    // If no selection is active, select the first ones from the received offers
    const selected = draft.selectedOption;

    if (!selected.subscription || !selected.hardware) {
        const tariff = findTariffById(draft.tariffs, selected.hardwareId);

        const subId = selected.subscriptionId || tariff?.tariffs[0]?.legacyGroupId;
        const hardwareId = selected.hardwareId || tariff?.hardware.hardwareId.toString();

        handleSelectOption(draft, subId, hardwareId);
    }

    draft.error = undefined;
};
